import { Injectable } from '@angular/core';
//import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GammeSite, ModelSite } from '../models/modelsite';
import { BOBCAT_API } from '../common/utils/api.bobcat';
import { StructureSite } from '../models/structuresite';
import { HttpService } from '../common/utils/http.service';

import { Store } from '@ngrx/store';
import * as fromRoot from '../common/appstore/index';
import * as layout from '../common/appstore/actions';

export interface IGammesSites {
  gammes: GammeSite;
}


@Injectable()
export class SitemodelService {

  constructor(
    private httpservice: HttpService,
    private store: Store<fromRoot.AppState>
  ) {
  }

  getGamme() {
    return <Observable<IGammesSites>>this.httpservice.get(BOBCAT_API.GAMMES_SITES).map((res: any) => {
      return res;
    });
  }

  saveStructureSite(structure: any, user_id: number, document_id: number) {
    let newstructure = JSON.stringify(structure);
    let params = {
      'structuresite': newstructure,
      'user_id': user_id.toString(),
      'document_id': document_id.toString()
    }

    this.httpservice.post(BOBCAT_API.SAVE_STRUCTURE, params).subscribe();
  }

  /*getStructureSite(user_id: number, document_id: number){
    let params = new HttpParams()
                .set('user_id', user_id.toString())
                .set('document_id', document_id.toString());
    this.httpservice.post(BOBCAT_API.STRUCTURE_SITE, params).subscribe((structure: StructureSite) => {
      this.store.dispatch(new layout.StructureSite(structure));
    });
  }*/

  getStructureSite(user_id: number, document_id: number): Observable<GammeSite> {
    let params =
      {
        'user_id': user_id.toString(),
        'document_id': document_id.toString()
      }
    return this.httpservice.post(BOBCAT_API.STRUCTURE_SITE, params).map((structure: GammeSite) => {
      return structure;
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/services/sitemodel.service.ts